import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Textarea } from '@noor/ui';
import type { ModalRenderProps } from '@noor/lib';
import { Can } from '@/entities/access';
import { useCreateNote } from '../model/use-create-note';

/** Create-note modal. Ported from cpanel `CreateNoteDialog`. */
export function CreateNoteModal({ payload, close }: ModalRenderProps<'create-note'>) {
  const { t } = useTranslation('orders');
  const [text, setText] = useState('');
  const mutation = useCreateNote(payload.orderId);

  const onSubmit = () => {
    if (!text.trim()) return;
    mutation.mutate(text.trim(), { onSuccess: close });
  };

  return (
    <Can permission="orders.notes.create">
      <Modal
        title={t('notes.create')}
        dismissible={!mutation.isPending}
        footer={
          <>
            <Button
              variant="soft"
              size="modal"
              shape="rounded"
              onClick={close}
              disabled={mutation.isPending}
            >
              {t('confirm.cancel')}
            </Button>
            <Button
              variant="dark"
              size="modal"
              shape="rounded"
              onClick={onSubmit}
              disabled={mutation.isPending || !text.trim()}
            >
              {t('notes.save')}
            </Button>
          </>
        }
      >
        <Textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={t('notes.placeholder')}
          rows={4}
        />
      </Modal>
    </Can>
  );
}
